<template>
  <img alt="Experian Logo" height="39" v-lazy="imgUrl" />
</template>

<script>
export default {
  name: "ExperianLogo",
  data () {
    return {
      imgUrl:  require('@/assets/img/affiliates/exp.png')
    }
  }
}
</script>

<style scoped>

</style>